export * from "./manifest-detail-view";
